import { render, staticRenderFns } from "./MT5.vue?vue&type=template&id=f07b01f8&"
import script from "./MT5.vue?vue&type=script&lang=js&"
export * from "./MT5.vue?vue&type=script&lang=js&"
import style0 from "./MT5.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports